module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-10-e2034a5727b229596581c1c48427fce6.svg";